import tw, { css, styled } from 'twin.macro'

export const StyledLabel = styled.label(() => [tw`font-black text-lg ml-6`])

const selectBaseStyle = css`
  ${tw`border-[0.5px] border-opacity-0 rounded-full pl-6 pr-10 py-4 transition appearance-none bg-no-repeat focus:outline-none focus-visible:ring-offset-2`}
  background-image: url("data:image/svg+xml;utf8,<svg fill='rgb(170, 170, 170)' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M12 17a1.002 1.002 0 0 1-.71-.29l-7-7a1.004 1.004 0 1 1 1.42-1.42l6.29 6.3 6.29-6.3a1.004 1.004 0 1 1 1.42 1.42l-7 7A1.001 1.001 0 0 1 12 17Z' /></svg>");
  background-position: calc(100% - 0.75rem) center;
  background-size: 1.25rem;
`

export const StyledSelect = styled.select(() => [selectBaseStyle])
